import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const MoreDots = ({
  closeDetail,
  detailString,
  duplicateString,
  duplicateTemplate,
  inCart,
  isDuplicate,
  isDropdownOpen,
  openDetail,
  removeString,
  removeTemplate,
  srcDetailIcon,
  srcDuplicateIcon,
  srcRemoveIcon,
  textStyle,
  toggleDropdown,
}) => (
  <div className={styles.dropdownDots}>
    <button className={styles.moreBtn} onClick={!isDuplicate && toggleDropdown}>
      <span className={styles.moreDot} />
      <span className={styles.moreDot} />
      <span className={styles.moreDot} />
    </button>
    {!isDuplicate &&
      isDropdownOpen && (
        <div className={styles.moreMenu}>
          <ul className={styles.moreMenuItems}>
            <li>
              <button className={styles.moreMenuButton} onClick={openDetail}>
                <img alt="details" src={srcDetailIcon} />
                <span className={styles.optionLabel} style={textStyle}>
                  {detailString}
                </span>
              </button>
            </li>
            {!inCart && (
              <li>
                <button
                  className={styles.moreMenuButton}
                  onClick={removeTemplate}
                >
                  <img alt="details" src={srcRemoveIcon} />
                  <span className={styles.optionLabel} style={textStyle}>
                    {removeString}
                  </span>
                </button>
              </li>
            )}
            <li>
              <button
                className={styles.moreMenuButton}
                onClick={duplicateTemplate}
              >
                <img alt="details" src={srcDuplicateIcon} />
                <span className={styles.optionLabel} style={textStyle}>
                  {duplicateString}
                </span>
              </button>
            </li>
          </ul>
        </div>
      )}
  </div>
);

export default enhance(MoreDots);
